<template>
    <AppLayout>
        <div class="bg-white">
            <div class="pt-6">
                <nav aria-label="Breadcrumb">
                    <ol role="list" class="mx-auto flex max-w-2xl items-center space-x-2 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                        <li v-for="breadcrumb in breadcrumbs" :key="breadcrumb.id">
                            <div class="flex items-center">
                                <a :href="breadcrumb.href" class="mr-2 text-sm font-medium text-slate-900">{{ breadcrumb.name
                                }}</a>
                                <svg width="16" height="20" viewBox="0 0 16 20" fill="currentColor" aria-hidden="true"
                                    class="h-5 w-4 text-slate-300">
                                    <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z" />
                                </svg>
                            </div>
                        </li>
                        <li v-if="product" class="text-sm">
                            <a :href="product.href" aria-current="page"
                                class="font-medium text-slate-500 hover:text-slate-600">{{ product.name }}</a>
                        </li>
                    </ol>
                </nav>

                <!-- Image gallery -->
                <div v-if="product" class="mx-auto mt-6 max-w-2xl sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-1 lg:gap-x-8 lg:px-8">
                    <img :src="product.image" :alt="product.imageAlt"
                        class="hidden w-full h-100 rounded-lg object-cover lg:block" />
                </div>

                <!-- Product info -->
                <div
                    v-if="product"
                    class="mx-auto max-w-2xl px-4 pt-10 pb-16 sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:grid-rows-[auto_auto_1fr] lg:gap-x-8 lg:px-8 lg:pt-16 lg:pb-24">
                    <div class="lg:col-span-2 lg:border-r lg:border-slate-200 lg:pr-8">
                        <h1 class="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{{ product.name }}</h1>
                    </div>

                    <!-- Options -->
                    <div v-if="product" class="mt-4 lg:row-span-3 lg:mt-0">
                        <h2 class="sr-only">Course information</h2>

                        <!-- Reviews -->
                        <div v-if="reviews" class="mt-6">
                            <h3 class="sr-only">Reviews</h3>
                            <div class="flex items-center">
                                <div class="flex items-center">
                                    <StarIcon v-for="rating in [0, 1, 2, 3, 4]" :key="rating"
                                        :class="[reviews.average > rating ? 'text-slate-900' : 'text-slate-200', 'size-5 shrink-0']"
                                        aria-hidden="true" />
                                </div>
                                <p class="sr-only">{{ reviews.average }} out of 5 stars</p>
                                <a :href="reviews.href"
                                    class="ml-3 text-sm font-medium text-primary-600 hover:text-primary-500">{{
                                        reviews.totalCount }} reviews</a>
                            </div>
                        </div>

                        <Button v-if="product" class="mt-6 w-full bg-primary-500 text-white hover:bg-primary-600"
                            label="Enroll now" @click="router.push({ name: 'checkout', params: { slug: product.slug } })">
                        </Button>
                    </div>

                    <div v-if="product" class="py-10 lg:col-span-2 lg:col-start-1 lg:border-r lg:border-slate-200 lg:pt-6 lg:pr-8 lg:pb-16">
                        <!-- Description and details -->
                        <div>
                            <h3 class="sr-only">Description</h3>

                            <div class="space-y-6">
                                <div>
                                    {{ product.description }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import { ref } from 'vue';
import { StarIcon } from '@heroicons/vue/20/solid';
import { onMounted } from 'vue';
import { getProductBySlug } from '@/services/productService';
import { useRouter } from 'vue-router';
import Button from 'primevue/button';
import AppLayout from '@/components/layouts/AppLayout.vue';

const router = useRouter();
const productSlug = router.currentRoute.value.params.slug;

// const pathSegments = window.location.pathname.split('/').filter(Boolean);

const product = ref(null);
const breadcrumbs = [
    { id: 1, name: 'Courses', href: '/courses' },
]

onMounted(async () => {
    const response = await getProductBySlug(productSlug);
    product.value = response.data;
    console.log(response.data);
});

// const reviews = { href: '#', average: 4, totalCount: 117 }
</script>